export default "__VITE_ASSET__DSUsvQWi__"